import { lang } from '@umu/ukit-lang';
/**
 * @description
 * @author wayou
 */

import React, { Component } from 'react';
import { services, components } from 'common';
const { Toast } = services;
const { Emg, If, Loading } = components;
import { getShareV2 } from '@umu/umu-api';
import './aiReportPicShare.scss';
/// ----------------
let requestStatusTimoutId: number = 0;

interface IAiReportPicShareProps {
    homeworkId: number;
    sharePicUrl?: string;
}

interface IAiReportPicShareState {
    generating: boolean;
    sharePicUrl: string;
}

export default class AiReportPicShare extends Component<IAiReportPicShareProps, IAiReportPicShareState> {
    constructor(props: IAiReportPicShareProps) {
        super(props);
        this.state = {
            generating: !props.sharePicUrl,
            sharePicUrl: props.sharePicUrl || '',
        };

        this.requestNotePic = this.requestNotePic.bind(this);
    }

    public componentWillUnmount() {
        if (requestStatusTimoutId) {
            clearTimeout(requestStatusTimoutId);
        }
    }

    public componentDidMount() {
        // 如果没有图片地址则请求生成图片并轮询生成状态
        const props = this.props;
        if (!props.sharePicUrl) {
            this.requestNotePic();
        }
    }

    public requestNotePic() {
        getShareV2(
            {
                obj_id: String(this.props.homeworkId),
                obj_type: 29 as any, // OBJ_TYPE_HOMEWORK_AI_REPORT，这个枚举在 node 端保存
                width: 684,
            },
            {
                poll_timeout_ms: 1000,
                use_puppeteer: true,
            },
        )
            .then((res) => {
                const picUrl = res.data.pic_url;
                this.setState({
                    generating: false,
                    sharePicUrl: picUrl!,
                });
            })
            .catch((e) => {
                Toast.show({
                    message: JSON.stringify(e),
                });
            });
    }

    public render() {
        const shareTip = lang('长按保存图片，分享到朋友圈或发送给朋友');
        return (
            <div className="ai-report-pic-share">
                <p className="ai-report-pic-share-tip">{shareTip}</p>
                <div className="ai-report-pic-share-frame">
                    <If condition={this.state.generating}>
                        <div className="pic-generating">
                            <Loading />
                        </div>
                    </If>
                    <If condition={!this.state.generating}>
                        <Emg src={this.state.sharePicUrl} />
                    </If>
                </div>
            </div>
        );
    }
}
